/* eslint-disable */
import { useTranslation } from "react-i18next";
import { Button, Table, TableCell, TableContainer, TableRow, TableHead, TableBody, FormControl } from '@mui/material';
import Box from '@mui/material/Box';
import { useState, useEffect } from 'react';
import PageInfo from 'components/PageInfo';
import queryString from 'query-string';
import { getEquipmentCategoriesByQuery } from 'components/axios/equipmentCategoryAxios';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import CustomSelect from 'components/select/CustomSelect';
import { getEquipmentsByQuery } from 'components/axios/equipmentAxios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import dayjs from "utils/dayjs";
import { getEquipmentsGroupCountByStatus } from 'components/axios/equipmentAxios';
import { useEnumApi } from 'contexts/EnumApiContext';
import { BootstrapInput, orderNumber, ROLE } from 'data/data';
import EquipmentExcelDownload from 'components/EquipmentExcelDownload';
import { getSearchFiltersEquipmentZones } from 'components/axios/equipmentZoneAxios';
import useConfig from "hooks/useConfig";
import { getCompaniesByQuery } from "components/axios/companyAxios";
// import CompanyEquipmentMappingLayer from "components/layer/CompanyEquipmentMappingLayer";

const EquipmentSetting = () => {
  const { getEnumValueByEnumNameAndCode, getEnumValueByEnumName, equipmentCategoryLevel1s, loginInfo } = useEnumApi();
  const { t, i18n } = useTranslation();
  const { mode } = useConfig();
  const location = useLocation();
  const navigate = useNavigate();

  const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
  const nantongCompanyId = process.env.REACT_APP_NANTONG_MANAGEMENT_COMPANY_NO;
  const lang = i18n.language.substring(0, 2);

  const [searchField, setSearchField] = useState('name');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [pageInfo, setPageInfo] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
  const [equipments, setEquipments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isParam, setIsParam] = useState(false);
  const [toggleStr, setToggleStr] = useState(true);

  const [equipmentOpStatus, setEquipmentOpStatus] = useState('');
  const [equipmentFaultStatus, setEquipmentFaultStatus] = useState('');
  const [zoneCategoryCode, setZoneCategoryCode] = useState('');
  const [stationId, setStationId] = useState('');
  const [managementCompanyId, setManagementCompanyId] = useState('');
  const [zoneId, setZoneId] = useState('');
  const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
  const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
  const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');

  const [managementCompanies, setManagementCompanies] = useState([]);
  const [zoneCategories, setZoneCategories] = useState([]);
  const [zones, setZones] = useState([]);
  const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
  const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);

  const searchFields = [{code:"name", title:t('message.common.subtitle.equipment.name')}, {code:"equipmentNo", title:t('message.common.subtitle.equipment.number')}];
  const [excelParam, setExcelParam] = useState('');

  let qs = queryString.parse(location.search);

  const [searchParam, setSearchParam] = useState({});
  const [searchParamString, setSearchParamString] = useState('');
  
  const handlePaging = (value) => {
    value = isNaN(value) ? 1 : value;
    setCurrentPage(value-1);
    setIsLoading(false);

    let searchParamCopy = {...searchParam};
    searchParamCopy.page = (value-1);
    setSearchParam(searchParamCopy);
  }

  useEffect(()=>{
    const searchOrders = searchParam.searchOrder;
    const searchParamCopy = {...searchParam};
    delete searchParamCopy.searchOrder;
    let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
    if (searchOrders && searchOrders.length > 0) {
      let sortString = '';
      searchOrders.forEach(order=>sortString+="&sort="+order.sort)
      searchString += sortString;
    }
    setSearchParamString("?"+searchString)
  }, [searchParam])

  useEffect(()=> {
    if (qs) {
      if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page);}
      if (qs.size) setPageSize(qs.size);
      if (qs.searchField) setSearchField(qs.searchField);
      if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);

      if (qs.searchOpStatus) setEquipmentOpStatus(qs.searchOpStatus);
      if (qs.searchStatus) setEquipmentFaultStatus(qs.searchStatus);
      if (qs.searchSubway) setZoneCategoryCode(qs.searchSubway);
      if (qs.searchStation) setStationId(qs.searchStation);
      if (qs.searchManagementCompanyId) setManagementCompanyId(qs.searchManagementCompanyId);
      if (qs.searchZone) setZoneId(qs.searchZone);
      if (qs.searchlevel1) setEquipmentCategoryLevel1Id(qs.searchlevel1);
      if (qs.searchlevel2) setEquipmentCategoryLevel2Id(qs.searchlevel2);
      if (qs.searchlevel3) setEquipmentCategoryLevel3Id(qs.searchlevel3);

      let searchParamCopy = {...searchParam};
      if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
      if (qs.size) {searchParamCopy.size = qs.size} ;
      if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
      if (qs.searchKeyword) {searchParamCopy.searchKeyword = qs.searchKeyword};
      if (qs.searchOpStatus) {searchParamCopy.searchOpStatus = qs.searchOpStatus};
      if (qs.searchStatus) {searchParamCopy.searchStatus = qs.searchStatus};
      if (qs.searchSubway) {searchParamCopy.searchSubway = qs.searchSubway};
      if (qs.searchStation) {searchParamCopy.searchStation = qs.searchStation};
      if (qs.searchManagementCompanyId) {searchParamCopy.searchManagementCompanyId = qs.searchManagementCompanyId};
      if (qs.searchZone) {searchParamCopy.searchZone = qs.searchZone};
      if (qs.searchlevel1) {searchParamCopy.searchlevel1 = qs.searchlevel1};
      if (qs.searchlevel2) {searchParamCopy.searchlevel2 = qs.searchlevel2};
      if (qs.searchlevel3) {searchParamCopy.searchlevel3 = qs.searchlevel3};
      if (qs.sort && qs.sort.length > 0) {
        let orders = [];
        let sortModel = [];
        if (!Array.isArray(qs.sort)) {
          orders.push({sort:qs.sort});
          sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
        } else {
          (qs.sort).forEach(order=>orders.push({sort:order}));
          qs.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
        }
        searchParamCopy.searchOrder = orders;
      } else {
        delete searchParamCopy.searchOrder
      };
      setSearchParam(searchParamCopy);
    }
    setIsParam(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qs.page, qs.size, qs.searchField, qs.searchKeyword, qs.searchOpStatus, qs.searchStatus
    , qs.searchSubway, qs.searchStation, qs.searchZone, qs.searchManagementCompanyId
    , qs.searchlevel1, qs.searchlevel2, qs.searchlevel3]);

  // 관리주체목록
  useEffect(()=>{
    if (platformServer !== 'NANTONG') {
      const param = { "type": "MAN", size : 100, sort : "info.name,asc" };
      getCompaniesByQuery(param).then((data) => {
        if (data && data._embedded) {
          const list = data._embedded?.companies?.map(item => {return { ...item, name: item.info?.name }});
          if (list) {
            setManagementCompanies(list);
          } else {
            setManagementCompanies([]);
          }
        } else {
          setManagementCompanies([]);
        }
      });
    }
  },[]);

  // 관리주체의 구역목록
  useEffect(()=>{
    if (managementCompanyId) {
      const equipmentZones = managementCompanies?.find(zc=>zc.id == managementCompanyId)?.equipmentZones;
      setZones(equipmentZones ?? [])
    } else {
      setZones([])
    }
  },[managementCompanyId, managementCompanies])

  // 난퉁의 호선목록
  useEffect(() => {
    const fetchAndSetZones = async () => {
      const data = await getSearchFiltersEquipmentZones();
      if (!data) return;

      const company = data.managementCompanies?.find(com => com.id == nantongCompanyId);
      if (company) {
        const categories = company.zoneCategories?.map(zc => ({
          ...zc,
          title: zc.name?.[lang]
        })) ?? [];
        
        setZoneCategories(categories);

        // 카테고리 로드 직후, 현재 선택된 zoneCategoryCode가 있다면 바로 zones까지 세팅
        if (zoneCategoryCode) {
          const foundCategory = categories.find(zc => zc.code === zoneCategoryCode);
          setZones(foundCategory?.zones ?? []);
        }
      }
    };

    fetchAndSetZones();
  }, [nantongCompanyId, lang, zoneCategoryCode]); // 관련 의존성을 통합

  // 난퉁의 역사목록
  useEffect(()=>{
    // console.log(zoneCategories)
    if (platformServer === 'NANTONG') {
      if (zoneCategoryCode) {
        const zonCategory = zoneCategories?.find(zc=>zc.code === zoneCategoryCode);
        setZones(zonCategory?.zones ?? [])
        // console.log(zonCategory)
        // console.log(zonCategory?.zones ?? [])
      } else {
        setZones([])
        // console.log(111)
      }
    }
  },[zoneCategoryCode])

    // 설비중분류 목록
  useEffect(()=>{
    if (equipmentCategoryLevel1Id) {
      const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
      getEquipmentCategoriesByQuery(param).then((data) => {
        if (data && data._embedded) {
          const list = data._embedded.equipmentCategories;
          if (list) {
            setEquipmentCategoryLevel2s(list);
          } else {
            setEquipmentCategoryLevel2s([]);
          }
        } else {
          setEquipmentCategoryLevel2s([]);
        }
        setEquipmentCategoryLevel3s([]);
      });
    }
  },[equipmentCategoryLevel1Id]);

  // 설비분류 목록
  useEffect(()=>{
    if (equipmentCategoryLevel2Id) {
      const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
      getEquipmentCategoriesByQuery(param).then((data) => {
        if (data && data._embedded) {
          const list = data._embedded.equipmentCategories;
          if (list) {
            setEquipmentCategoryLevel3s(list);
          } else {
            setEquipmentCategoryLevel3s([]);
          }
        } else {
          setEquipmentCategoryLevel3s([]);
        }
      });
    }
  },[equipmentCategoryLevel2Id]);

  // 목록
  useEffect(()=> {
    if (!isLoading && !isNaN(currentPage) && isParam && getEnumValueByEnumName("EquipmentFaultStatus")) {
      equipmentList();
      equipmentGroupCountList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, isLoading, equipmentFaultStatus, getEnumValueByEnumName("EquipmentFaultStatus"), isParam]);
  
  let [equipmentGroupCounts, setEquipmentGroupCounts] = useState([]);
  let [totalEquipmentGroupCount, setTotalEquipmentGroupCount] = useState(0);
  let [problemEquipmentGroupCount, setProblemEquipmentGroupCount] = useState(0);

  const equipmentGroupCountList = async() => {
    let param = {
      // opStatus : equipmentOpStatus,
      // "equipmentCtgr.parent.parent.id" : equipmentCategoryLevel1Id,
      // "equipmentCtgr.parent.id" : equipmentCategoryLevel2Id,
      // "equipmentCtgr.id" : equipmentCategoryLevel3Id,
    };
    // if (equipmentFaultStatus === 'problem') {
    //   param.latestCommYmd = 'lte('+connectProblemDay+')';
    // } else {
    //   if (equipmentFaultStatus === 'sum')
    //     param.status = '';
    //   else
    //     param.status = equipmentFaultStatus;
    //   let keyword = searchKeyword;
    //   if (searchKeyword) {
    //       if (searchField && (searchField === 'name' || searchField === 'equipmentNo')) {
    //         keyword = 'contains('+searchKeyword+')';
    //       }

    //       if (searchField === 'name') {
    //         param.name = keyword;
    //       } else if (searchField === 'equipmentNo') {
    //         param.equipmentNo = keyword;
    //       }
    //   }
    // }
    await getEquipmentsGroupCountByStatus(param).then((res)=>{
      equipmentGroupCounts = [];
      totalEquipmentGroupCount = 0;
      if (res != null) {
        let isInclude = false;
        let statussData = res.data;

        let equipmentFaultStatuss = getEnumValueByEnumName("EquipmentFaultStatus");
        if (equipmentFaultStatuss) {

          equipmentFaultStatuss.map(status => status.code === 'O4_C' ? status.sort = 4 : '')
          equipmentFaultStatuss.map(status => status.code === 'O3_A' ? status.sort = 3 : '')
          equipmentFaultStatuss.map(status => status.code === 'O2_I' ? status.sort = 2 : '')
          equipmentFaultStatuss.map(status => status.code === 'O1_N' ? status.sort = 1 : '')
          orderNumber(equipmentFaultStatuss, "sort")
        
          equipmentFaultStatuss.map(function(item1) {
            isInclude = false;
            statussData.map(function(item2) {
              if (item2.groups.includes(item1.code)) {
                equipmentGroupCounts.push(...[{
                  name : item1.code,
                  id : item1.code,
                  title : item1.title,
                  count : item2.count,
                }]);
                totalEquipmentGroupCount += item2.count;
                isInclude = true;
              }
            })

            if (!isInclude) {
              let defaultStatus = [{
                name : item1.code,
                id : item1.code,
                title : item1.title,
                count : 0,
              }];
              equipmentGroupCounts.push(...defaultStatus);
            }
          })
        }
        setEquipmentGroupCounts(equipmentGroupCounts);
        setTotalEquipmentGroupCount(totalEquipmentGroupCount);
      }
    });
  }

  const equipmentList = async(curPage=currentPage) => {
    isNaN(curPage) && setCurrentPage(0);
    isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
    setCurrentPage(curPage)

    let param = {
      opStatus : equipmentOpStatus,
      "equipmentCtgr.parent.parent.id" : equipmentCategoryLevel1Id,
      "equipmentCtgr.parent.id" : equipmentCategoryLevel2Id,
      "equipmentCtgr.id" : equipmentCategoryLevel3Id,
      page : curPage,
      size : pageSize,
    };
    if (zoneCategoryCode) {
      param["zone.category.code"] = zoneCategoryCode;
    }
    if (stationId) {
      param['zone.id'] = stationId;
    }
    if (managementCompanyId) {
      param['managementCompany.id'] = managementCompanyId;
    }
    if (zoneId) {
      param['zone.id'] = zoneId;
    }
    if (equipmentFaultStatus === 'problem') {
      const connectProblemDay = dayjs.tz(process.env.REACT_APP_TIMEZONE).subtract(7, "day").format(t('message.common.text.date.format.date'));
      param.latestCommYmd = 'lte('+connectProblemDay+')';
    } else {
      if (equipmentFaultStatus === 'sum')
        param.status = '';
      else
        param.status = equipmentFaultStatus;
      let keyword = searchKeyword;
      if (searchKeyword) {
          if (searchField && (searchField === 'name' || searchField === 'equipmentNo')) {
            keyword = 'contains('+searchKeyword+')';
          }

          if (searchField === 'name') {
            param.name = keyword;
          } else if (searchField === 'equipmentNo') {
            param.equipmentNo = keyword;
          }
      }
    }
    await getEquipmentsByQuery(param).then((data)=>{
      if (data != null) {
        if(data.page) {
          setPageInfo(data.page);
        } else {
          setCurrentPage(0);
          pageInfo = {
            size : pageInfo.size,
            totalElements : 0,
            totalPages : 0,
            number : 0
          }
          setPageInfo(pageInfo);
        }
        if(data._embedded) {
          setEquipments(data._embedded.equipments);
          return data.page.totalElements;
        } else {
          setEquipments([]);
        }
        return 0;
      }
    }).then((res)=>{
      const totalCount = res;
      let paramCopy = {...param};
      delete paramCopy.page;
      paramCopy.page = 0;
      delete paramCopy.size;
      paramCopy.size = totalCount;
      setExcelParam(paramCopy);
      setIsLoading(true);
    });
  }

  const handleInput = (event) => {
    event.preventDefault();
    setSearchKeyword(event.target.value.trim());
  };

  const handleOnKeyPress = e => {
    if (e.key === 'Enter') {
      handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
    }
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setCurrentPage(0);
    pageInfo.number = 0;
    setPageInfo(pageInfo);
    equipmentList(0);
    equipmentGroupCountList();
    setExcelParam('');

    let searchParamCopy = {...searchParam};
    searchParamCopy.page = 0;
    if (pageSize) {searchParamCopy.size = pageSize};
    if (searchField) {searchParamCopy.searchField = searchField};
    if (searchKeyword) {searchParamCopy.searchKeyword = searchKeyword};
    if (equipmentOpStatus) {searchParamCopy.searchOpStatus = equipmentOpStatus};
    if (equipmentFaultStatus) {searchParamCopy.searchStatus = equipmentFaultStatus};
    if (zoneCategoryCode) {searchParamCopy.searchSubway = zoneCategoryCode};
    if (stationId) {searchParamCopy.searchStation = stationId};
    if (managementCompanyId) {searchParamCopy.searchManagementCompanyId = managementCompanyId};
    if (zoneId) {searchParamCopy.searchZone = zoneId};
    if (equipmentCategoryLevel1Id) {searchParamCopy.searchlevel1 = equipmentCategoryLevel1Id};
    if (equipmentCategoryLevel2Id) {searchParamCopy.searchlevel2 = equipmentCategoryLevel2Id};
    if (equipmentCategoryLevel3Id) {searchParamCopy.searchlevel3 = equipmentCategoryLevel3Id};
    setSearchParam(searchParamCopy)
    const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
    navigate("?"+paramString)
  };

  const statusTapSearch = (vCode) => {
    setCurrentPage(0);
    pageInfo.number = 0;
    setPageInfo(pageInfo);
    setEquipmentFaultStatus(vCode);
    initSearch();

    let searchParamCopy = {...searchParam};
    searchParamCopy.page = 0;
    if (pageSize) {searchParamCopy.size = pageSize};
    if (searchField) {searchParamCopy.searchField = searchField};
    searchParamCopy.searchStatus = vCode;
    searchParamCopy.searchKeyword = '';
    searchParamCopy.searchOpStatus = '';
    searchParamCopy.searchSubway = '';
    searchParamCopy.searchStation = '';
    searchParamCopy.searchManagementCompanyId = '';
    searchParamCopy.searchZone = '';
    searchParamCopy.searchlevel1 = '';
    searchParamCopy.searchlevel2 = '';
    searchParamCopy.searchlevel3 = '';
    setSearchParam(searchParamCopy)
    const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
    navigate("?"+paramString)
  };

  const initSearch = ()  => {
    setEquipmentOpStatus('');
    setZoneCategoryCode('');
    setStationId('');
    setManagementCompanyId('');
    setZoneId('');
    setEquipmentCategoryLevel1Id('');
    setEquipmentCategoryLevel2Id('');
    setEquipmentCategoryLevel3Id('');
    setToggleStr(!toggleStr);
    setSearchKeyword('');
    setCurrentPage(0);
    setIsLoading(false);
    setExcelParam('')
  };

  let falutStatusSelectColor = "";
  let statusColor = "";
  let statusName = "";
  // const searchParam = '?searchField='+searchField+'&searchKeyword='+searchKeyword+'&page='+currentPage+'&size='+pageSize
  // +"&searchStatus="+equipmentFaultStatus+"&searchOpStatus="+equipmentOpStatus
  // +"&searchSubway="+zoneCategoryCode+"&searchStation="+stationId+"&searchManagementCompanyId="+managementCompanyId+"&searchZone="+zoneId
  // +"&searchlevel1="+equipmentCategoryLevel1Id+"&searchlevel2="+equipmentCategoryLevel2Id+"&searchlevel3="+equipmentCategoryLevel3Id;

  if (equipmentFaultStatus === '' || equipmentFaultStatus === "sum") {
    falutStatusSelectColor = " selected";
  }
  return (
    <>
      <div className="cal">
        <div className='search_section'>
          <ul className='condition' style={{marginTop:"px"}}>
            <li></li>
            <li className={`sum${falutStatusSelectColor}`} onClick={() => statusTapSearch('sum')} style={{cursor:"pointer"}}>{t('message.common.registration.equipment')}: {totalEquipmentGroupCount}</li>
          </ul>

          <div style={{display:"flex",justifyContent:"space-between", alignItems:"center"}}>
            <Box component="form">
              <div>
                <div>
                {getEnumValueByEnumName("EquipmentOpStatus") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={equipmentOpStatus}
                      label={t('message.common.subtitle.opStatus')}
                      labelName={t('message.common.subtitle.opStatus')}
                      name={'equipmentOpStatus'}
                      defaultValue={equipmentOpStatus}
                      onChange={(e)=>{
                        setEquipmentOpStatus(e.target.value);
                      }}
                      list={getEnumValueByEnumName("EquipmentOpStatus")}
                  />
                  </FormControl>
                  }
                  {(platformServer === 'NANTONG' && zoneCategories) &&
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={zoneCategoryCode}
                      label={t('message.common.subtitle.subwayline')}
                      labelName={t('message.common.subtitle.subwayline')}
                      name={'subway'}
                      defaultValue={zoneCategoryCode}
                      onChange={(e)=>{
                        setZoneCategoryCode(e.target.value);
                        setStationId('')
                      }}
                      list={zoneCategories}
                  />
                  </FormControl>
                  }
                  {(platformServer === 'NANTONG' && zones ) && (
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={stationId}
                      label={t('message.common.subtitle.station')}
                      labelName={t('message.common.subtitle.station')}
                      name={'station'}
                      value={stationId}
                      onChange={(e)=>{
                        setStationId(e.target.value)
                      }}
                      list={zones}
                  />
                  </FormControl>
                  )}
                  {(platformServer !== 'NANTONG' && managementCompanies) &&
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={managementCompanyId}
                      label={getEnumValueByEnumNameAndCode("CompanyType", 'MAN')?.[0]?.title}
                      labelName={getEnumValueByEnumNameAndCode("CompanyType", 'MAN')?.[0]?.title}
                      name={'managementCompanyId'}
                      defaultValue={managementCompanyId}
                      onChange={(e)=>{
                        setManagementCompanyId(e.target.value);
                        setZoneId('')
                      }}
                      list={managementCompanies}
                  />
                  </FormControl>
                  }
                  {(platformServer !== 'NANTONG' && zones ) && (
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={zoneId}
                      label={t('message.common.subtitle.zone')}
                      labelName={t('message.common.subtitle.zone')}
                      name={'zoneId'}
                      defaultValue={zoneId}
                      onChange={(e)=>{
                        setZoneId(e.target.value)
                      }}
                      list={zones}
                  />
                  </FormControl>
                  )}
                  {loginInfo.role === ROLE.SA.code && equipmentCategoryLevel1s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel1Id}
                      label={t('message.common.subtitle.equipment.level1')}
                      labelName={t('message.common.subtitle.equipment.level1')}
                      name={'level1'}
                      defaultValue={equipmentCategoryLevel1Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel1Id(e.target.value);
                        setEquipmentCategoryLevel2Id('');
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel1s}
                  />
                  </FormControl>
                  }
                  {loginInfo.role === ROLE.SA.code && equipmentCategoryLevel2s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel2Id}
                      label={t('message.common.subtitle.equipment.level2')}
                      labelName={t('message.common.subtitle.equipment.level2')}
                      name={'level2'}
                      defaultValue={equipmentCategoryLevel2Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel2Id(e.target.value);
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel2s}
                  />
                  </FormControl>
                  }
                  {loginInfo.role === ROLE.SA.code && equipmentCategoryLevel3s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel3Id}
                      label={t('message.common.subtitle.equipment.level3')}
                      labelName={t('message.common.subtitle.equipment.level3')}
                      name={'level3'}
                      defaultValue={equipmentCategoryLevel3Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel3Id(e.target.value);
                      }}
                      list={equipmentCategoryLevel3s}
                  />
                  </FormControl>
                  }
                  <div style={{display:"inline-block"}}>
                  {searchFields && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={searchField}
                      label={t('message.common.btn.search')}
                      labelName={t('message.common.btn.search')}
                      name={'searchField'}
                      defaultValue={searchField}
                      onChange={(e)=>{
                        setSearchField(e.target.value);
                      }}
                      list={searchFields}
                  />
                  </FormControl>
                  }
                    <FormControl sx={{ m: 1 }} variant="standard">
                      <BootstrapInput id="demo-customized-textbox" className="search_moniter" style={{ width : "130px" }} value={searchKeyword} onChange={handleInput} onKeyPress={handleOnKeyPress}/>
                    </FormControl>

                    <Button variant="contained" style={{marginTop:"12px",padding:"4px 15px"}} onClick={handleSearch}>
                      <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                    </Button>
                  </div>
                </div>
              </div>
            </Box>
            <div className="btn_right">
              <Link to={'./add'+searchParamString}><Button variant="contained" color="primary">{t('message.common.btn.write')}</Button></Link>
              <EquipmentExcelDownload excelParam={excelParam} />
            </div>
          </div>
        </div>
      </div>

      <Box 
          id="tableDiv"
          sx={{
            mt: 3,
            padding: "20px",
            borderRadius: "20px",
            overflow: "hidden",
            background: `${mode === 'dark' ? "#182131": "#fff"}`,
            border: `${mode === 'dark' ? "1px solid rgba(255,255,255,0.06)": "1px solid #30363d"}`,
            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          }}
        >
        <TableContainer>
          <Table sx={{ minWidth: 1400 }} aria-label="simple table" className="list_table">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">No.</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.opStatus')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.recent.inspection')}</TableCell>
                {platformServer === 'NANTONG' && <TableCell className="th" align="center">{t('message.common.subtitle.subwayline')}</TableCell>}
                {platformServer === 'NANTONG' && <TableCell className="th" align="center">{t('message.common.subtitle.station')}</TableCell>}
                {platformServer !== 'NANTONG' && <TableCell className="th" align="center">{getEnumValueByEnumNameAndCode("CompanyType", 'MAN')?.[0]?.title}</TableCell>}
                {platformServer !== 'NANTONG' && <TableCell className="th" align="center">{t('message.common.subtitle.zone')}</TableCell>}
                {platformServer !== 'NANTONG' && <TableCell className="th" align="center">{getEnumValueByEnumNameAndCode("CompanyType", 'MNT')?.[0]?.title}</TableCell>}
                <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level1')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level2')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level3')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.equipment.name')}</TableCell>
                <TableCell className="th mobile-none" align="center">{t('message.common.subtitle.equipment.number')}</TableCell>
                <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                <TableCell className="th" align="center">{getEnumValueByEnumNameAndCode("CompanyType", 'MFR')?.[0]?.title}</TableCell>
                <TableCell className="th mobile-none" align="center">{t('message.common.subtitle.iot.installation')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {equipments && equipments.map(function(con,i) {
                let linkUrl = './modify/'+equipments[i].id+searchParamString;
                return (
                <TableRow key={i}>
                  <TableCell><Link to={linkUrl}>{pageInfo.totalElements-((currentPage)*pageInfo.size)-i}</Link></TableCell>
                  <TableCell><Link to={linkUrl}>{equipments[i].opStatus && getEnumValueByEnumNameAndCode("EquipmentOpStatus", equipments[i].opStatus)?.[0]?.title}</Link></TableCell>
                  <TableCell><Link to={linkUrl}>{equipments[i].latestCommYmd}&nbsp;</Link></TableCell>
                  {platformServer === 'NANTONG' && <TableCell><Link to={linkUrl}>{equipments[i].zone?.category?.name?.[i18n.language.substring(0, 2)]}&nbsp;</Link></TableCell>}
                  {platformServer === 'NANTONG' && <TableCell><Link to={linkUrl}>{equipments[i].zone?.name}&nbsp;</Link></TableCell>}
                  {platformServer != 'NANTONG' && <TableCell><Link to={linkUrl}>{equipments[i].managementCompany?.info?.name}&nbsp;</Link></TableCell>}
                  {platformServer != 'NANTONG' && <TableCell><Link to={linkUrl}>{equipments[i].zone?.name}&nbsp;</Link></TableCell>}
                  {platformServer != 'NANTONG' && <TableCell><Link to={linkUrl}>{equipments[i].maintenanceCompany?.info?.name}&nbsp;</Link></TableCell>}
                  <TableCell><Link to={linkUrl}>{equipments[i].equipmentCtgr && equipments[i].equipmentCtgr.parent && equipments[i].equipmentCtgr.parent.parent && equipments[i].equipmentCtgr.parent.parent.name}</Link></TableCell>
                  <TableCell><Link to={linkUrl}>{equipments[i].equipmentCtgr && equipments[i].equipmentCtgr.parent && equipments[i].equipmentCtgr.parent.name}</Link></TableCell>
                  <TableCell><Link to={linkUrl}>{equipments[i].equipmentCtgr && equipments[i].equipmentCtgr.name}</Link></TableCell>
                  <TableCell><Link to={linkUrl}>{equipments[i].name}</Link></TableCell>
                  <TableCell className='mobile-none'><Link to={linkUrl}>{equipments[i].equipmentNo}</Link></TableCell>
                  <TableCell><Link to={linkUrl}>{equipments[i].location}</Link></TableCell>
                  <TableCell><Link to={linkUrl}>{equipments[i].manufacturingCompany?.info?.name}&nbsp;</Link></TableCell>
                  <TableCell className="mobile-none"><Link to={linkUrl}>{equipments[i].iotInstlYn ? 'O':'X'}</Link></TableCell>
                </TableRow> 
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
        
        <div className="btn_right">
          {/* <CompanyEquipmentMappingLayer fileId="3009" /> */}
          <Link to={'./add'+searchParamString}><Button variant="contained" color="primary">{t('message.common.btn.write')}</Button></Link>
          <EquipmentExcelDownload excelParam={excelParam} />
        </div>
        
        <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
      </Box>
    </>
  );
}
 
export default EquipmentSetting;